import { UserProfile } from "../../../application/UserProfile";
import { ColDef } from "../../grids/columns/colDef";
import { RecordDataSource } from "../../grids/recordDataSource";
import { IGridSettings } from "../../grids/settings/gridSettingsService";

export class RecordGridViewController {
  static $inject = ["userProfile"];

  gridDataSource!: RecordDataSource;
  gridSettings: IGridSettings | undefined;
  columns!: ColDef[];
  defaultSort: string | undefined;
  nameSingular: string = "";
  namePlural: string | undefined;
  showAddButton: boolean = false;
  showAddButtonPermission: string | undefined;

  constructor(private readonly userProfile: UserProfile) {}

  $onInit() {
    if (!this.namePlural) {
      this.namePlural = `${this.nameSingular}s`;
    }
  }

  shouldShowAddButton(): boolean {
    const permission = this.showAddButtonPermission;
    return (
      this.showAddButton &&
      (!permission || this.userProfile.hasPermission(permission))
    );
  }
}
